import { MfaVerifyScreen } from "@/interactors/MfaVerifyScreen";

export default function MfaVerifyPage() {
  return <MfaVerifyScreen />;
}
